import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './interceptors/token.interceptor';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ScrollToTopComponent } from './components/scroll-to-top/scroll-to-top.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { LogoutComponent } from './components/logout/logout.component';

@NgModule({
  declarations: [
    SpinnerComponent,
    ScrollToTopComponent,
    LogoutComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[
    SpinnerComponent,
    ScrollToTopComponent
  ],
  providers:[
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ]
})
export class SharedModule { }
